@if (status === ACTIVE_STATUS) {
  <span href="javascript:void(0);" class="badge badge-success">{{status}}</span>
}
@if (status === INACTIVE_STATUS) {
  <span href="javascript:void(0);" class="badge badge-light">{{status}}</span>
}
@if (status === DEFAULT_STATUS) {
  <span href="javascript:void(0);" class="badge badge-info">{{status}}</span>
}
